import { render, staticRenderFns } from "./sponsor-form.vue?vue&type=template&id=2060853d&scoped=true"
import script from "./sponsor-form.vue?vue&type=script&lang=js"
export * from "./sponsor-form.vue?vue&type=script&lang=js"
import style0 from "./sponsor-form.vue?vue&type=style&index=0&id=2060853d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060853d",
  null
  
)

export default component.exports